import axios from 'axios';
import { withRetry } from './apiRetry';
import { sessionRedirect } from './sessionRedirect';
import { tryRefresh } from './refreshToken';

// Always use relative URLs — both preview (K8s ingress) and production (girgit.app)
// route /api/* to the backend, so cross-origin requests are never needed
const BACKEND_URL = '';

export const getAdminToken = () => {
  return localStorage.getItem('admin_token');
};

export const setAdminToken = (token) => {
  localStorage.setItem('admin_token', token);
};

export const removeAdminToken = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
  localStorage.removeItem('admin_refresh_token');
};

export const getAdminUser = () => {
  const userStr = localStorage.getItem('admin_user');
  return userStr ? JSON.parse(userStr) : null;
};

export const setAdminUser = (user) => {
  localStorage.setItem('admin_user', JSON.stringify(user));
};

export const isAdminAuthenticated = () => {
  return !!getAdminToken();
};

// Axios instance for admin API calls
export const adminApi = axios.create({
  baseURL: BACKEND_URL,
  timeout: 30000,
});

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Retry transient failures before giving up
withRetry(adminApi);

// 401 handler — try silent refresh, fall back to session-expiry redirect.
// This mirrors employeeApi and clientApi so no portal can hang on stale tokens.
adminApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthCall = /\/auth\/(login|refresh)/i.test(url);
    if (status === 401 && !isAuthCall && !error.config.__hasRetriedAuth) {
      const newToken = await tryRefresh('admin');
      if (newToken) {
        error.config.__hasRetriedAuth = true;
        error.config.headers.Authorization = `Bearer ${newToken}`;
        return adminApi.request(error.config);
      }
      sessionRedirect('admin');
    }
    return Promise.reject(error);
  }
);
